// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WrDZ","question":"styles_question__2BNuW","inputVisibleButton":"styles_inputVisibleButton__2F7XH","note":"styles_note__1BXf4"};